import React from "react";
import { Link } from "react-router-dom";
import { motion as m } from "framer-motion";
import { Heart } from "lucide-react";
import { useSettings } from "../../../context/SettingsContext";

const AdminLogo = ({ isSidebarOpen, loading }) => {
  const { logo } = useSettings();

  return (
    /* Tinggi ditingkatkan ke h-24 agar sejajar dengan Topbar */
    <div className="h-24 flex items-center px-6 border-b border-stone-800 shrink-0 overflow-hidden">
      <Link to="/admin/dashboard" className="flex items-center group h-full w-full">
        {loading ? (
          <div className="h-10 w-10 bg-stone-800 animate-pulse rounded-lg" />
        ) : logo ? (
          <div className="flex items-center">
            <img
              src={logo}
              alt="Logo"
              /* Ukuran logo disesuaikan sedikit lebih besar h-10 */
              className="h-10 w-auto object-contain transition-all group-hover:scale-105"
            />
            <m.span
              initial={false}
              animate={{ 
                opacity: isSidebarOpen ? 1 : 0,
                x: isSidebarOpen ? 0 : -10,
                display: isSidebarOpen ? "block" : "none" 
              }}
              className="ml-3 font-bold text-white tracking-wider uppercase text-xs whitespace-nowrap"
            >
              Event Management
            </m.span>
          </div>
        ) : (
          /* PLACEHOLDER LOGO (Sesuai gaya NavbarLogo) */
          <div className="flex items-center w-full">
            <div className="shrink-0 group-hover:bg-blue-50/5 transition-all">
               <Heart className="text-amber-500 transition-transform group-hover:scale-110" fill="currentColor" size={28} />
            </div>
            
            <m.div
              initial={false}
              animate={{ 
                opacity: isSidebarOpen ? 1 : 0,
                display: isSidebarOpen ? "flex" : "none" 
              }}
              className="ml-3 flex flex-col justify-center transition-all duration-300"
            >
              <span className="text-[11px] font-black tracking-[0.2em] text-white uppercase leading-none mb-1">
                Pasang Logo
              </span>
              <span className="text-[9px] font-medium tracking-[0.3em] text-amber-500 uppercase leading-none opacity-80">
                Anda Disini
              </span>
            </m.div>
          </div>
        )}
      </Link>
    </div>
  );
};

export default AdminLogo;